import { isAfter, parse, subMonths } from 'date-fns';
import * as yup from 'yup';
import { FIELD_REQUIRED_MSG } from '../../validation';
import {
  MAX_WEIGHT,
  MIN_WEIGHT,
  WEIGHT_ERROR,
  WEIGHT_FORMAT_ERROR,
} from './constants';

const youngestPup = subMonths(new Date(), 3);

export const schema = yup.object().shape({
  gender: yup.string().required(FIELD_REQUIRED_MSG),
  name: yup.string().required('pup name is required'),
  year: yup
    .string()
    .required(`Your pup's year of birth is required`)
    .notOneOf(['0'], `Your pup's year of birth is required`),
  month: yup
    .string()
    .required(`Your pup's month of birth is required`)
    .notOneOf(['0'], `Your pup's month of birth is required`)
    .test(
      'is-not-too-young',
      'Sorry, we cannot accept pups less than 3mo old.',
      (month, { parent }) => {
        if (parent.month) {
          const date = parse(
            `${parent.year}-${month}-${parent.day || '01'}`,
            'yyyy-MM-dd',
            new Date(),
          );
          return isAfter(youngestPup, date);
        }
        return true;
      },
    ),
  day: yup.string(),
  breeds: yup.array().max(2, 'Maximum of two breeds allowed'),
  weight: yup
    .number()
    .required(FIELD_REQUIRED_MSG)
    .integer(WEIGHT_FORMAT_ERROR)
    .typeError(FIELD_REQUIRED_MSG)
    .max(MAX_WEIGHT, WEIGHT_ERROR)
    .min(MIN_WEIGHT, WEIGHT_ERROR),
  idealWeight: yup
    .number()
    .integer(WEIGHT_FORMAT_ERROR)
    .nullable()
    .typeError(FIELD_REQUIRED_MSG)
    .max(MAX_WEIGHT, WEIGHT_ERROR)
    .min(MIN_WEIGHT, WEIGHT_ERROR)
    .transform(v => (isNaN(v) ? null : v)),
  spayedStatus: yup
    .bool()
    .required(FIELD_REQUIRED_MSG)
    .typeError(FIELD_REQUIRED_MSG),
});
